import {
    BooleanInput,
    DateInput,
    FormDataConsumer,
    NumberInput,
    required, SelectField,
    SelectInput,
    SimpleForm,
    TextField, TextInput,
} from "react-admin";
import { useForm } from "react-final-form";
import {FormProps} from "../../shared/types";
import {initField, initInput} from "../../shared/utils";
import {Grid, IconButton} from "@material-ui/core";
import {CustomToolbar} from "../../components/CustomToolbar";
import React from "react";
import {ReferenceInputBank} from "../../components/reference-inputs/ReferenceInputBank";
import ClearIcon from "@material-ui/icons/Clear";

const ClearCollectionTypeButton = ({ canEdit }: {canEdit: any}) => {
    const form = useForm();

    return (
        <IconButton
            size="small"
            disabled={!canEdit}
            onClick={() => form.change("collection_type", null)}
        >
            <ClearIcon fontSize="small" />
        </IconButton>
    );
};

export const PaymentScheduleStatusEditForm = (props: FormProps) => {

    return (
        <SimpleForm
            {...props}
            toolbar={
                <CustomToolbar canEdit={props.canEdit} canDelete={props.canDelete} />
            }
        >
            <Grid spacing={2} container alignItems="center" style={{ width: "100%" }}>
                <Grid item xs={12}>
                    Tipo stato: <SelectField
                        {...initField("status", props.fieldOptions, "array")}
                        choices={props.fieldOptions.status.choices}
                    />
                </Grid>
                <Grid item xs={6}>
                    <DateInput
                        {...initInput("date", props.fieldOptions, props.canEdit)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <NumberInput
                        {...initInput("amount", props.fieldOptions, props.canEdit)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs>
                            <SelectInput
                                {...initInput(
                                    "collection_type",
                                    props.fieldOptions,
                                    props.canEdit,
                                    "array"
                                )}
                                choices={props.fieldOptions.collection_type.choices}
                            />
                        </Grid>

                        <Grid item>
                            <ClearCollectionTypeButton canEdit={props.canEdit} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <ReferenceInputBank {...initInput("bank_id", props.fieldOptions, props.canEdit)}
                                        label="Banca" defaultValue={1} />
                </Grid>
                <Grid item xs={12}>

                    <TextInput
                        {...initInput("notes", props.fieldOptions, props.canEdit)}
                    />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
